import { DialogRef } from "@angular/cdk/dialog";
import { Component } from "@angular/core";
interface SelectOption {
  value: number | string;
  label: string;
}
@Component({
  selector: "fury-add-ticket",
  templateUrl: "./add-ticket.component.html",
  styleUrls: ["./add-ticket.component.scss"],
})
export class AddTicketComponent {
  constructor(private dialogRef: DialogRef<AddTicketComponent>) {}
  // Form model
  callType: string = "0"; // 0 = واردة , 1 = صادرة
  inquiryType: string = "0"; // None by default
  inquirySubType: string = "0"; // None
  ticketBranch: string = "77"; // TestBranch
  message: string = "";

  // Conditional fields
  surveyType: string = "0";
  locationTo: string = "";
  transferToWhom: string = "";
  complaintText: string = "";
  nationalId: string = "";
  areaFound: string = "";
  monthlySalary: number | null = null;
  preferredMobile: string = "";
  jobTitle: string = "";
  dateOfEmployment: string = new Date().toISOString().split("T")[0]; // today

  // Visibility flags
  showSurveySelector = false;
  showTransferToLocation = false;
  showTransferToWhom = false;
  showTransferComplain = false;
  showPersonalNational = false;
  showLostFoundArea = false;
  showPersonalSalary = false;
  showPersonalPhone = false;
  showPersonalJobTitle = false;
  showPersonalEmploymentDate = false;

  // Options (you can fetch from API later)
  readonly callTypes = [
    { value: "0", label: "مكالمة واردة" },
    { value: "1", label: "مكالمة صادرة" },
  ];

  readonly inquiryTypes = [
    { value: "0", label: "None" },
    { value: "1", label: "Inquiry" },
    { value: "3", label: "Transfer" },
    { value: "4", label: "Complain" },
    { value: "15", label: "Lost & Found" },
    { value: "16", label: "Personnal Affairs" },
  ];

  readonly branches = [{ value: "77", label: "TestBranch" }];

  readonly surveyOptions = [
    { value: "0", label: "None" },
    { value: "1", label: "ChatGPT" },
    { value: "2", label: "Google" },
    { value: "3", label: "FaceBook" },
    { value: "4", label: "InBranch" },
    { value: "5", label: "Instgram" },
    { value: "6", label: "Outdoor Ads" },
    { value: "7", label: "Tiktok" },
    { value: "8", label: "Whatsapp" },
    { value: "9", label: "TV" },
    { value: "10", label: "Friend Referal" },
  ];

  ngOnInit() {
    this.onTicketTypeChange(this.inquiryType);
  }

  onTicketTypeChange(value: string) {
    // Reset all conditional fields
    this.resetConditionalFields();

    this.inquiryType = value;

    switch (value) {
      case "1": // Inquiry
        this.showSurveySelector = true;
        break;

      case "3": // Transfer
        this.showTransferToLocation = true;
        this.showTransferToWhom = true;
        break;

      case "4": // Complain
        this.showTransferComplain = true;
        break;

      case "15": // Lost & Found
        this.showLostFoundArea = true;
        break;

      case "16": // Personal Affairs
        this.showPersonalNational = true;
        this.showPersonalSalary = true;
        this.showPersonalPhone = true;
        this.showPersonalJobTitle = true;
        this.showPersonalEmploymentDate = true;
        break;

      default:
        // None → nothing extra
        break;
    }
  }

  private resetConditionalFields() {
    this.showSurveySelector = false;
    this.showTransferToLocation = false;
    this.showTransferToWhom = false;
    this.showTransferComplain = false;
    this.showPersonalNational = false;
    this.showLostFoundArea = false;
    this.showPersonalSalary = false;
    this.showPersonalPhone = false;
    this.showPersonalJobTitle = false;
    this.showPersonalEmploymentDate = false;

    // Optional: clear values
    this.surveyType = "0";
    this.locationTo = "";
    this.transferToWhom = "";
    this.complaintText = "";
    this.nationalId = "";
    this.areaFound = "";
    this.monthlySalary = null;
    this.preferredMobile = "";
    this.jobTitle = "";
    this.dateOfEmployment = new Date().toISOString().split("T")[0];
  }

  save() {
    // Implement your save logic here (e.g. call service)
    console.log("Saving ticket:", {
      callType: this.callType,
      inquiryType: this.inquiryType,
      message: this.message,
      // ... other fields
    });
    this.close();
  }

  close() {
    this.dialogRef.close();
    // Implement dialog close (MatDialogRef, or your custom emitter)
    console.log("Dialog closed");
  }
}
